(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-colour-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__tapCardSwatches) return;
    window.__tapCardSwatches = true;

    function parts(el) {
      var card = el.closest('.card-wrapper') || el.closest('.card');
      var list = el.closest('.card-swatches');
      return {
        card: card,
        list: list,
        img: card ? card.querySelector('.card__media .media img') : null
      };
    }

    function setImage(img, src, srcset) {
      if (!img || !src) return;
      if (!img.hasAttribute('data-original-src')) {
        img.setAttribute('data-original-src', img.getAttribute('src') || '');
        img.setAttribute('data-original-srcset', img.getAttribute('srcset') || '');
      }
      img.setAttribute('srcset', srcset || src);
      img.setAttribute('src', src);
    }

    function selectedImage(card, img) {
      return {
        src: card.getAttribute('data-selected-src') || img.getAttribute('data-original-src'),
        srcset: card.getAttribute('data-selected-srcset') || img.getAttribute('data-original-srcset')
      };
    }

    function select(swatch) {
      var p = parts(swatch);
      if (!p.card || !p.list) return;

      p.list.querySelectorAll('.card-swatch').forEach(function (el) {
        var on = el === swatch;
        el.classList.toggle('is-selected', on);
        el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // Photo
      var src = swatch.getAttribute('data-preview-src');
      if (src && p.img) {
        setImage(p.img, src, swatch.getAttribute('data-preview-srcset'));
        p.card.setAttribute('data-selected-src', src);
        p.card.setAttribute('data-selected-srcset', swatch.getAttribute('data-preview-srcset') || src);
        p.card.classList.add('is-swatch-selected');
      }

      // Links to the product page open with this colour selected
      var base = p.list.getAttribute('data-product-url');
      var url = swatch.getAttribute('data-variant-url');
      if (base && url) {
        p.card.querySelectorAll('a[href]').forEach(function (a) {
          var href = a.getAttribute('href').split('?')[0];
          if (href === base || href.slice(-base.length) === base) a.setAttribute('href', url);
        });
      }

      // Add to cart button adds this colour
      var available = swatch.getAttribute('data-available') === 'true';
      var form = p.card.querySelector('.quick-add product-form form, .quick-add form[data-type="add-to-cart-form"]');
      if (form) {
        var input = form.querySelector('input[name="id"]');
        var button = form.querySelector('button[name="add"]');
        if (input) {
          input.value = swatch.getAttribute('data-variant-id');
          input.disabled = !available;
        }
        if (button) {
          button.disabled = !available;
          var label = button.querySelector('span');
          if (label) label.textContent = available ? p.list.getAttribute('data-add-text') : p.list.getAttribute('data-sold-text');
        }
      }
    }

    document.addEventListener('click', function (e) {
      var swatch = e.target.closest && e.target.closest('.card-swatch');
      if (!swatch) return;
      e.preventDefault();
      e.stopPropagation();
      select(swatch);
    });

    // Desktop: hovering previews a colour, leaving returns to the selected one
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseover', function (e) {
        var swatch = e.target.closest && e.target.closest('.card-swatch');
        if (!swatch) return;
        var p = parts(swatch);
        var src = swatch.getAttribute('data-preview-src');
        if (!p.img || !src) return;
        setImage(p.img, src, swatch.getAttribute('data-preview-srcset'));
        p.card.classList.add('is-swatch-preview');
        p.list.querySelectorAll('.card-swatch.is-previewing').forEach(function (el) { el.classList.remove('is-previewing'); });
        swatch.classList.add('is-previewing');
      });
      document.addEventListener('mouseout', function (e) {
        var list = e.target.closest && e.target.closest('.card-swatches');
        if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
        var p = parts(list);
        if (p.img && p.img.hasAttribute('data-original-src')) {
          var sel = selectedImage(p.card, p.img);
          p.img.setAttribute('srcset', sel.srcset);
          p.img.setAttribute('src', sel.src);
        }
        p.card.classList.remove('is-swatch-preview');
        list.querySelectorAll('.card-swatch.is-previewing').forEach(function (el) { el.classList.remove('is-previewing'); });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tap-kit-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('tap-kit-selector')) return;

    // Read the colour the shopper has picked on this page (pink / black / etc.)
    function currentColour() {
      var words = ['pink', 'black', 'green', 'cream', 'white', 'floral'];
      var picked = [];
      document.querySelectorAll('variant-selects input:checked, variant-selects select').forEach(function (el) {
        picked.push(String(el.value || '').toLowerCase());
      });
      for (var i = 0; i < words.length; i++) {
        for (var j = 0; j < picked.length; j++) {
          if (picked[j].indexOf(words[i]) !== -1) return words[i];
        }
      }
      return '';
    }

    function bestVariant(variants, colour) {
      if (!colour || !variants.length) return null;
      var best = null;
      var bestScore = 0;
      variants.forEach(function (v) {
        var score = v.t.split(colour).length - 1;
        if (v.a) score += 0.5;
        if (score > bestScore) { bestScore = score; best = v; }
      });
      return bestScore >= 1 ? best : null;
    }

    class TapKitSelector extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.addEventListener('click', function (e) {
          var link = e.target.closest('a.tks__item[data-kit]');
          if (!link) return;
          var data = self.querySelector('script[data-kit-variants="' + link.getAttribute('data-kit') + '"]');
          var variants = [];
          try { variants = data ? JSON.parse(data.textContent) : []; } catch (err) {}
          var match = bestVariant(variants, currentColour());
          if (!match) return;
          e.preventDefault();
          link.classList.add('is-loading');
          window.location.href = link.getAttribute('href').split('?')[0] + '?variant=' + match.id;
        });
      }
    }

    window.customElements.define('tap-kit-selector', TapKitSelector);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tap-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('tap-sticky-atc')) return;

    class TapStickyAtc extends HTMLElement {
      connectedCallback() {
        var info = document.querySelector('.product__info-container') || document;
        this.form = info.querySelector('product-form form[action*="/cart/add"]');
        this.mainBtn = this.form ? this.form.querySelector('[name="add"]') : null;
        this.btn = this.querySelector('.tsa__btn');
        this.meta = this.querySelector('.tsa__meta');
        if (!this.form || !this.mainBtn) return;

        // Move to <body> so it isn't clipped by the product layout
        if (this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }

        var self = this;
        this.btn.addEventListener('click', function () {
          self.refreshMain();
          if (!self.mainBtn || self.mainBtn.disabled) return;
          self.mainBtn.click();
        });

        this.update = this.update.bind(this);
        this.update();
        this.observer = new IntersectionObserver(function (entries) {
          var e = entries[0];
          var past = !e.isIntersecting && e.boundingClientRect.top < 0;
          self.classList.toggle('is-visible', past);
          self.setAttribute('aria-hidden', past ? 'false' : 'true');
          self.btn.tabIndex = past ? 0 : -1;
        });
        this.observer.observe(this.mainBtn);

        // Keep price, options and button state in sync with the page
        this.mo = new MutationObserver(this.update);
        this.mo.observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
        document.addEventListener('change', this.update);
      }

      // The theme can re-render the form when the variant changes, so look it up again
      refreshMain() {
        var info = document.querySelector('.product__info-container') || document;
        var form = info.querySelector('product-form form[action*="/cart/add"]');
        var btn = form ? form.querySelector('[name="add"]') : null;
        if (btn && btn !== this.mainBtn) {
          if (this.observer && this.mainBtn) this.observer.unobserve(this.mainBtn);
          this.mainBtn = btn;
          if (this.observer) this.observer.observe(btn);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mo) this.mo.disconnect();
        document.removeEventListener('change', this.update);
      }

      update() {
        if (this.updating) return;
        this.updating = true;
        var self = this;
        requestAnimationFrame(function () {
          self.refreshMain();
          var info = document.querySelector('.product__info-container') || document;
          var opts = [];
          info.querySelectorAll('variant-selects input:checked, variant-selects select').forEach(function (el) {
            if (el.value) opts.push(el.value.replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s*\*.*?\*\s*/g, ' ').trim());
          });
          var price = info.querySelector('.price .price__sale:not([hidden]) .price-item--sale, .price .price-item--regular');
          var sale = info.querySelector('.price--on-sale .price-item--sale');
          var priceText = ((sale || price) ? (sale || price).textContent : '').trim();
          self.meta.textContent = opts.concat(priceText ? [priceText] : []).join(' · ');

          var label = self.mainBtn.querySelector('span');
          self.btn.textContent = label ? label.textContent.trim() : self.btn.textContent;
          self.btn.disabled = self.mainBtn.disabled;
          self.updating = false;
        });
      }
    }

    window.customElements.define('tap-sticky-atc', TapStickyAtc);
  })();
  } catch(e) { console.error(e); }
})();

})();
